// extracted by mini-css-extract-plugin
module.exports = {"joinPageLink":"PageTitle_joinPageLink__6VR8u"};